// Copyright ©️ 2025 eVolve MEP, LLC

import React from 'react';

import { ActionIcon, Avatar, Flex, Loader, Text } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';
import { AgGridStyleTooltip } from 'components/Mantine/AgGridStyleTooltip';
import { KANBAN_LABEL_HEIGHT } from 'components/Mantine/Kanban/constants';
import { isNil } from 'helpers/isNotNil';

type Props = {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  entireCount?: number;
  loading?: boolean;
  rotate?: boolean;
};

export const CountIndicatorAndCollapseButton = ({ collapsed, setCollapsed, entireCount, rotate, loading }: Props) => (
  <Flex
    justify="center"
    align="center"
    ml={rotate ? -KANBAN_LABEL_HEIGHT : undefined}
    style={{
      width: KANBAN_LABEL_HEIGHT,
      height: KANBAN_LABEL_HEIGHT,
      transform: rotate ? 'rotate(-90deg)' : undefined,
    }}
  >
    <AgGridStyleTooltip label={collapsed ? 'Expand' : 'Collapse'} withArrow>
      <ActionIcon
        color="gray"
        className="hover-title--on"
        size="sm"
        variant="light"
        onClick={() => setCollapsed(!collapsed)}
      >
        <EvolveIcon size="sm" icon={collapsed ? 'ExpandPane' : 'CollapsePane'} />
      </ActionIcon>
    </AgGridStyleTooltip>
    <Avatar className="hover-title--off" radius="100%" size="sm">
      {loading || isNil(entireCount) ? (
        <Loader size="xs" />
      ) : (
        <Text fz="xs" c={entireCount > 0 ? 'dark' : undefined} fw={500}>
          {entireCount > 999 ? '999+' : entireCount}
        </Text>
      )}
    </Avatar>
  </Flex>
);
